export default "{\n    \"title\": \"Edit Planned Maintenance\",\n    \"name\": \"Name\",\n    \"submitLabel\": \"Save\"\n}\n"